import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Grid, Typography} from "@material-ui/core";

class PBNPlayingInfo extends Component {
    render() {

        return (
            <Grid container style={{padding:'5px'}}>
                <Grid item xs={12}>
                    <Typography variant={"body1"} inline>Tricks Played: </Typography>
                    <Typography variant={"body1"} inline color={"primary"}>{this.props.trickNumber}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant={"body1"} inline>NS Tricks: </Typography>
                    <Typography variant={"body1"} inline color={"primary"}>{this.props.tricksNS}</Typography>
                </Grid>
                <Grid item xs={12} wrap={"nowrap"}>
                    <Typography variant={"body1"} inline>EW Tricks: </Typography>
                    <Typography variant={"body1"} inline color={"primary"}>{this.props.tricksEW}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant={"body1"}>&nbsp;</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant={"body1"}>&nbsp;</Typography>
                </Grid>
            </Grid>
        );
    }
}

PBNPlayingInfo.propTypes = {
    trickNumber: PropTypes.number,
    tricksNS: PropTypes.number,
    tricksEW: PropTypes.number
}

export default PBNPlayingInfo;